import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

@Injectable()
export class TraceInterceptor implements HttpInterceptor {

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      tap(event => {
        if (event.type === 4) {
          const traceId = this.extractTraceId(event);
          if (traceId) {
            TraceService.setCurrentTraceId(traceId);
          }
        }
      }),
      catchError((error: HttpErrorResponse) => {
        const traceId = this.extractTraceId(error);
        if (traceId) {
          TraceService.setCurrentTraceId(traceId);
        }
        return throwError(error);
      })
    );
  }

  private extractTraceId(response: any): string | null {
    if (response.headers) {
      return response.headers.get('x-cloud-trace-context') || 
             response.headers.get('X-Cloud-Trace-Context') ||
             response.headers.get('x-trace-id') ||
             response.headers.get('X-Trace-Id');
    }
    
    if (response.body) {
      return response.body.traceId || 
             response.body.trace_id || 
             response.body['x-cloud-trace-context'];
    }
    
    if (response.error) {
      return response.error.traceId || 
             response.error.trace_id || 
             response.error['x-cloud-trace-context'];
    }
    
    return null;
  }
}

@Injectable({
  providedIn: 'root'
})
export class TraceService {
  private static currentTraceId: string | null = null;
  
  static setCurrentTraceId(traceId: string) {
    this.currentTraceId = traceId;
  }
  
  static getCurrentTraceId(): string | null {
    return this.currentTraceId;
  }
  
  static clearTraceId() {
    this.currentTraceId = null;
  }
}
